module.exports = __webpack_public_path__ + "img/undraw_no_data_re_kwbl.12ba1e51.png";